export interface FeedItem {
  id: number;
  category: string;
  title: string;
  summary: string;
  tag: string;
  heat: string;
  time: string;
  image: string;
  color: string;
}

export interface TimelineStep {
  time: string;
  title: string;
  text: string;
}

export const categories = [
  { key: "全部", label: "全部情报" },
  { key: "科技", label: "科技数码" },
  { key: "文娱", label: "文娱八卦" },
  { key: "财经", label: "商业财经" },
  { key: "社会", label: "社会观察" },
  { key: "体坛", label: "体坛电竞" },
  { key: "国际", label: "国际视野" },
];

export const categoryColors: Record<string, string> = {
  全部: "bg-foreground-800",
  科技: "bg-primary-600",
  文娱: "bg-accent-600",
  财经: "bg-secondary-600",
  社会: "bg-primary-500",
  体坛: "bg-accent-700",
  国际: "bg-secondary-500",
};

export const hotTags = [
  "国产AI翻车实录",
  "顶流综艺停摆",
  "联名周边崩盘",
  "直播切片大战",
  "跨国代购跑路",
  "冠军退役风波",
];

export interface HotItem {
  rank: number;
  title: string;
  tag: string;
  heat: string;
  trend: "up" | "down" | "new";
}

export const hotBoard: HotItem[] = [
  { rank: 1, title: "国产AI助手深夜“翻车”：一句口误引爆全网二创", tag: "科技", heat: "286万", trend: "up" },
  { rank: 2, title: "顶流选秀综艺突发停摆，导师团集体沉默引猜疑", tag: "文娱", heat: "241万", trend: "new" },
  { rank: 3, title: "新消费茶饮联名礼盒上架秒空，二手价暴涨十倍", tag: "财经", heat: "198万", trend: "up" },
  { rank: 4, title: "网红带货博主被曝“发往假仓”，粉丝集体要求退款", tag: "社会", heat: "167万", trend: "down" },
  { rank: 5, title: "国足新帅首秀三球逆转，评论区彻底“破防”", tag: "体坛", heat: "152万", trend: "up" },
  { rank: 6, title: "某科技峰会演示翻车，核心卖点当场“失灵”", tag: "科技", heat: "138万", trend: "up" },
  { rank: 7, title: "海外顶流明星来华演出官宣，票价被炒出天价", tag: "文娱", heat: "121万", trend: "new" },
  { rank: 8, title: "跨境电商“二选一”风波升级，中小卖家联名发声", tag: "财经", heat: "98万", trend: "down" },
  { rank: 9, title: "高校食堂“天价套餐”引热议，校方连夜回应", tag: "社会", heat: "86万", trend: "up" },
  { rank: 10, title: "电竞选手转会费刷新纪录，俱乐部深夜官宣", tag: "体坛", heat: "74万", trend: "new" },
];

export const feedItems: FeedItem[] = [
  {
    id: 1,
    category: "科技",
    title: "国产AI助手“翻车”事件全梳理：一次误读如何燎原",
    summary: "从一句模糊回应的截图流出，到全网玩梗二创，再到官方深夜补发说明。我们按时间线还原了这次乌龙事件如何从技术小瑕疵演变为全民话题。",
    tag: "技术翻车",
    heat: "28.6万",
    time: "2小时前",
    image: "https://readdy.ai/api/search-image?query=a%20playful%20illustration%20of%20a%20small%20friendly%20AI%20robot%20assistant%20blinking%20question%20marks%20over%20a%20laptop%20screen%20with%20chat%20bubbles%2C%20coral%20red%20and%20mint%20green%20flat%20vector%20style%2C%20warm%20cream%20background%2C%20trending%20tech%20news%20mood&width=800&height=600&seq=feed-tech-ai&orientation=landscape",
    color: "bg-primary-600",
  },
  {
    id: 2,
    category: "文娱",
    title: "顶流综艺停摆48小时：从舞台事故到节目组回应",
    summary: "一场舞台设备的小故障，为何让节目被紧急叫停？我们盘点节目组的两次声明、选手经纪公司的回应，以及网友吵翻的三大疑点。",
    tag: "综艺停摆",
    heat: "24.1万",
    time: "4小时前",
    image: "https://readdy.ai/api/search-image?query=a%20dramatic%20spotlight%20stage%20with%20empty%20microphone%20stand%20and%20confetti%20midair%2C%20cinematic%20warm%20lights%20in%20coral%20and%20amber%2C%20flat%20editorial%20illustration%2C%20entertainment%20variety%20show%20news%20mood&width=800&height=600&seq=feed-ent-show&orientation=landscape",
    color: "bg-accent-600",
  },
  {
    id: 3,
    category: "财经",
    title: "联名茶饮礼盒“秒空”背后：饥饿营销还是真火？",
    summary: "开售即售罄、二手价翻十倍，这款联名礼盒到底藏着什么？我们拆解了首发备货量、黄牛链路与品牌方的定价策略。",
    tag: "联名经济",
    heat: "19.8万",
    time: "6小时前",
    image: "https://readdy.ai/api/search-image?query=an%20open%20premium%20gift%20box%20with%20bubble%20milk%20tea%20cups%20and%20pastel%20merch%20badges%20spilling%20out%2C%20coral%20amber%20cream%20palette%2C%20clean%20flat%20product%20illustration%2C%20limited%20collaboration%20merchandise%20mood&width=800&height=600&seq=feed-fin-box&orientation=landscape",
    color: "bg-secondary-600",
  },
  {
    id: 4,
    category: "社会",
    title: "带货翻车还能信吗？一场“假仓”疑云的警示",
    summary: "粉丝晒出的物流单显示发货地与宣称产地不符，涉事博主直播回应漏洞百出。这起事件再度把直播电商的选品与售后问题摆上台面。",
    tag: "直播乱象",
    heat: "16.7万",
    time: "9小时前",
    image: "https://readdy.ai/api/search-image?query=flat%20illustration%20of%20live%20streaming%20shopping%20set%20with%20parcel%20boxes%20and%20shipping%20labels%2C%20questioning%20speech%20bubbles%2C%20warm%20coral%20and%20grey%20cream%20tones%2C%20consumer%20protection%20news%20mood&width=800&height=600&seq=feed-soc-live&orientation=landscape",
    color: "bg-primary-500",
  },
  {
    id: 5,
    category: "体坛",
    title: "三球逆转之夜：国足新帅的战术实验与球迷“情绪过山车”",
    summary: "落后、扳平、绝杀，90分钟里发生了什么？我们从首发阵型变化、换人节奏与定位球配合，复盘这令人窒息的逆转时刻。",
    tag: "逆转之夜",
    heat: "15.2万",
    time: "12小时前",
    image: "https://readdy.ai/api/search-image?query=energetic%20soccer%20stadium%20at%20night%20with%20players%20celebrating%20a%20comeback%20goal%2C%20confetti%20and%20spotlights%20in%20coral%20and%20mint%20green%2C%20dynamic%20flat%20sports%20illustration%2C%20winning%20mood&width=800&height=600&seq=feed-sport-soccer&orientation=landscape",
    color: "bg-accent-700",
  },
  {
    id: 6,
    category: "科技",
    title: "峰会现场翻车后：这家厂商为何坚持“不删视频”？",
    summary: "演示失败并不可怕，可怕的是一声不吭。厂商公开保留完整录播并追加开发日志，反而赢得了不少路人的好感与讨论。",
    tag: "危机公关",
    heat: "13.8万",
    time: "昨天",
    image: "https://readdy.ai/api/search-image?query=modern%20tech%20conference%20stage%20with%20large%20screen%20showing%20an%20error%20glitch%20and%20a%20presenter%20in%20front%2C%20flat%20editorial%20illustration%20in%20coral%2C%20mint%20and%20cream%2C%20startup%20pitch%20mood&width=800&height=600&seq=feed-tech-conf&orientation=landscape",
    color: "bg-primary-700",
  },
  {
    id: 7,
    category: "文娱",
    title: "海外顶流来华开唱：一张票里的“抢票经济学”",
    summary: "开票当天系统崩溃、转票平台价格翻倍，跨国演出市场的抢票乱象何时能解？我们聊聊主办方的限购规则与黄牛的技术博弈。",
    tag: "演出市场",
    heat: "12.1万",
    time: "昨天",
    image: "https://readdy.ai/api/search-image?query=concert%20ticket%20in%20hand%20in%20front%20of%20blurred%20crowd%20lights%2C%20ticket%20scalping%20concept%20with%20glowing%20phone%20screens%2C%20warm%20coral%20amber%20cream%20tones%2C%20flat%20editorial%20illustration&width=800&height=600&seq=feed-ent-concert&orientation=landscape",
    color: "bg-accent-500",
  },
  {
    id: 8,
    category: "财经",
    title: "跨境电商“二选一”再起波澜，中小卖家何去何从",
    summary: "平台流量规则调整引发卖家阵营分化，一场关于渠道选择权的大讨论正在进行。我们梳理了事件始末与各方最新表态。",
    tag: "平台博弈",
    heat: "9.8万",
    time: "前天",
    image: "https://readdy.ai/api/search-image?query=flat%20illustration%20of%20cross%20border%20ecommerce%20warehouse%20with%20shipping%20boxes%20and%20two%20arrows%20pointing%20in%20opposite%20directions%2C%20amber%20coral%20mint%20cream%20palette%2C%20business%20competition%20mood&width=800&height=600&seq=feed-fin-cross&orientation=landscape",
    color: "bg-secondary-700",
  },
];

export interface DeepEvent {
  id: number;
  category: string;
  title: string;
  lede: string;
  source: string;
  reading: string;
  updated: string;
  steps: TimelineStep[];
  image: string;
  imageAlt: string;
}

export const deepEvents: DeepEvent[] = [
  {
    id: 1,
    category: "深度洞察",
    title: "「机器人也想当主播」：一次串台风波的完整时间线",
    lede: "从素人晒出的一条语音到百万播放的“串台”名场面，本期深度栏目用七个关键节点，为你还原这颗瓜从播种到烂熟的全过程，并探讨背后真正值得讨论的技术边界问题。",
    source: "吃瓜中心 · 编辑部深度组",
    reading: "约 8 分钟读完",
    updated: "更新于 09-06 22:30",
    image: "https://readdy.ai/api/search-image?query=a%20cinematic%20wide%20illustration%20of%20a%20newsroom%20with%20multiple%20timeline%20screens%2C%20magnifying%20glass%20and%20newspaper%20clippings%20collage%2C%20coral%20red%2C%20mint%20green%20and%20cream%20flat%20style%2C%20in%20depth%20journalism%20and%20fact%20checking%20mood&width=1200&height=800&seq=deep-banner-01&orientation=landscape",
    imageAlt: "吃瓜中心深度时间线插画",
    steps: [
      { time: "09-03 14:20", title: "线索出现", text: "有网友在短视频平台晒出一段自称与某AI语音助手的对话，声称对方“一本正经地串台播起了新闻”，片段开始小范围流传。" },
      { time: "09-03 23:05", title: "二创爆发", text: "多个大V跟进转发并配上趣味配音，片段播放量数小时内突破百万，相关话题冲上热搜，评论区出现大量表情包玩梗。" },
      { time: "09-04 09:00", title: "疑点出现", text: "细心的网友发现音频疑似被后期剪辑拼接过，原始语境被断章取义，讨论方向从“好笑”转向“这是不是真的”。争议开始发酵。" },
      { time: "09-04 18:40", title: "厂商回应", text: "涉事厂商深夜发布说明，称已定位到特定条件下的回答缺陷，正在推送修复，并呼吁理性看待单条非典型交互。" },
      { time: "09-05 11:10", title: "舆论分化", text: "支持者认为回应坦诚、处理及时；质疑者则要求公开完整交互日志。相关技术话题讨论量不降反升，成为持续热点。" },
      { time: "09-06 15:00", title: "定论与反思", text: "官方修复版本上线，并公开了问题复现说明。事件热度回落，但关于AI生成内容可信度与责任边界的讨论仍在继续。" },
    ],
  },
];

export interface WeeklyItem {
  id: number;
  title: string;
  cover: string;
  tag: string;
  abstract: string;
  views: string;
}

export const weeklyItems: WeeklyItem[] = [
  {
    id: 1,
    title: "本周瓜榜 Top1：一场“翻车”背后的传播学",
    cover: "https://readdy.ai/api/search-image?query=colorful%20infographic%20collage%20of%20trending%20hashtags%20and%20newspaper%20headlines%20over%20a%20playful%20background%2C%20coral%20red%20amber%20mint%20cream%20flat%20vector%20style%2C%20weekly%20roundup%20newsletter%20mood&width=640&height=420&seq=weekly-01&orientation=landscape",
    tag: "本周最热",
    abstract: "从一条截图到全网刷屏，信息如何完成“三级跳”？",
    views: "328万阅读",
  },
  {
    id: 2,
    title: "一周吃瓜备忘：五颗值得回看的熟瓜",
    cover: "https://readdy.ai/api/search-image?query=five%20floating%20round%20cards%20each%20with%20a%20news%20headline%20and%20icon%20in%20a%20fanned%20layout%2C%20coral%20mint%20amber%20cream%20flat%20illustration%2C%20weekly%20digest%20mood&width=640&height=420&seq=weekly-02&orientation=landscape",
    tag: "事件盘点",
    abstract: "错过的瓜不用慌，吃瓜中心把来龙去脉都给你捋顺了。",
    views: "204万阅读",
  },
  {
    id: 3,
    title: "别急着站队：吃瓜前先看这三件事",
    cover: "https://readdy.ai/api/search-image?query=illustration%20of%20a%20megaphone%20and%20shields%20checking%20facts%20with%20magnifying%20glass%20and%20stop%20hand%20sign%2C%20coral%20amber%20cream%20flat%20style%2C%20media%20literacy%20and%20rumor%20checking%20mood&width=640&height=420&seq=weekly-03&orientation=landscape",
    tag: "理性吃瓜",
    abstract: "信源、时间线、是否反转，三问之后你再发表意见也不迟。",
    views: "176万阅读",
  },
  {
    id: 4,
    title: "本周热梗词库：这些暗号你听懂了吗？",
    cover: "https://readdy.ai/api/search-image?query=colorful%20typography%20collage%20of%20internet%20meme%20catchphrases%20and%20speech%20bubbles%2C%20vibrant%20coral%20mint%20amber%20on%20cream%2C%20playful%20flat%20vector%2C%20internet%20culture%20mood&width=640&height=420&seq=weekly-04&orientation=landscape",
    tag: "热梗词典",
    abstract: "跟上全网节奏，先学会这些最新“暗语”。",
    views: "142万阅读",
  },
];

export const faqItems = [
  {
    q: "吃瓜中心的资讯来源可靠吗？",
    a: "吃瓜中心的信息主要来自权威媒体公开报道与多信源交叉比对，编辑部会为每一条热点标注信源链接并注明核实状态，尽量还原事件全貌而非单一说法。未证实的信息一律标注「待核实」，不给谣言留发酵空间。",
  },
  {
    q: "如何判断一条爆料是不是真的？",
    a: "建议先看三件事：一看信源，是否有当事人或权威机构回应；二看时间线，事件是否仍在发酵、有无原始截图佐证；三看是否反转，避免只听单方面说法。吃瓜中心会在文章里清晰区分「已证实」与「未证实」部分，帮你理性吃瓜。",
  },
  {
    q: "我错过了之前的热点，从哪里补课？",
    a: "你可以从首页的「每周盘点」与「深度时间线」栏目补课，每期都按起因、经过、反转、落点做了完整梳理，通常几分钟就能掌握一颗瓜的全貌，不用在各大平台反复拼图。",
  },
  {
    q: "事件正在发酵时，吃瓜中心会实时更新吗？",
    a: "会的。对于仍在持续发酵的高热事件，我们会在「事件速递」中持续追加进展，并在文章顶部标注最后更新时间，确保你看到的是最新、最完整的脉络，而不是过时片段。",
  },
  {
    q: "如何向吃瓜中心投稿爆料或提供线索？",
    a: "你可以通过页面底部的订阅表单留下邮箱，或在联系方式板块向我们投稿线索。编辑部会先核实来源与事实，确认无误后再安排整理发布，并对采用线索的读者表示感谢。",
  },
];

export const navLinks = [
  { label: "今日热搜", href: "#hot" },
  { label: "事件速递", href: "#feed" },
  { label: "深度时间线", href: "#deep" },
  { label: "每周盘点", href: "#weekly" },
  { label: "吃瓜百科", href: "#faq" },
  { label: "关于中心", href: "#about" },
];